import { render, staticRenderFns } from "./SetpointEditDialog.vue?vue&type=template&id=bc1b28da&scoped=true"
import script from "./SetpointEditDialog.vue?vue&type=script&lang=ts"
export * from "./SetpointEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./SetpointEditDialog.vue?vue&type=style&index=0&id=bc1b28da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1b28da",
  null
  
)

export default component.exports